import {Box} from "@mui/material";
import {useMemo} from "react";

import {useTimezone} from "../../hooks/useTimezone";
import {
    countPerformers,
    getSessionCounts
} from "../../helpers/PerformerMetricHelper";
import SeatCountMetric from "./SeatCountMetric";
import SessionPerformerCount from "./SessionPerformerCount";

export default function PerformerMetrics({shiftPlans, currentDate, bookingStats, performerMetrics}) {
    const {timezone} = useTimezone();

    const performerCounts = useMemo(() => 
        performerMetrics || countPerformers(shiftPlans), 
        [performerMetrics, shiftPlans]
    );
    const scheduledPerformerCount = performerCounts.scheduled;
    const availablePerformerCount = performerCounts.total;

    const sessionCounts = useMemo(() => 
        getSessionCounts(bookingStats, currentDate, timezone),
        [bookingStats, currentDate, timezone]
    );
    const bookedSeats = sessionCounts.booked;
    const totalSeats = sessionCounts.total;

    return (
        <Box 
            display='flex' 
            justifyContent='space-between'
            alignItems='center'
            flexDirection={{xs: 'column', md: 'row'}}
            sx={{marginX: '0.3rem'}}>
            {
                availablePerformerCount > 0
                && 
                <SessionPerformerCount scheduledPerformerCount={scheduledPerformerCount} availablePerformerCount={availablePerformerCount}/>
            }
            {
                totalSeats > 0
                &&
                <SeatCountMetric bookedSeats={bookedSeats} totalSeats={totalSeats} />
            }
        </Box>
    );
}